import { gql } from '@apollo/client';
import ProjectFragment, { ProjectItem } from '../fragments/project';

export const SEARCH_PAGE_PROJECTS_QUERY = gql`
  query searchQuery(
    $offset: Int
    $perPage: Int
    $slug: String
    $termsTaxonomy: String
    $termsSlug: String
  ) {
    projectListCarouselQuery: projects(
      request: {
        offset: $offset
        perPage: $perPage
        slug: $slug
        terms: { taxonomy: $termsTaxonomy, slug: $termsSlug }
      }
    ) {
      totalCount
      totalPage
      items {
        ...ProjectFields
      }
    }
  }
  ${ProjectFragment}
`;

export interface SearchPageProjectsQueryVars {
  offset: number;
  perPage: number;
  slug: string;
  termsTaxonomy: string;
  termsSlug: string;
}

export const SEARCH_PAGE_ADVANCE_PROJECT_QUERY = gql`
  query searchQuery(
    $offset: Int
    $perPage: Int
    $priceMin: Float
    $priceMax: Float
    $freeText: String
    $propertyType: [String]
    $slug: String
    $termsTaxonomy: String
    $termsSlug: String
  ) {
    projectListCarouselQuery: projects(
      request: {
        offset: $offset
        perPage: $perPage
        slug: $slug
        priceMin: $priceMin
        priceMax: $priceMax
        search: { keyword: $freeText, opr: "OR" }
        custom: { propertyType: $propertyType }
        terms: { taxonomy: $termsTaxonomy, slug: $termsSlug }
      }
    ) {
      totalCount
      totalPage
      items {
        ...ProjectFields
      }
    }
  }
  ${ProjectFragment}
`;

export interface SearchPageAdvanceProjectsQueryVars {
  offset: number;
  perPage: number;
  priceMin: number;
  priceMax: number;
  freeText: string;
  propertyType: string[];
  slug: string;
  termsTaxonomy: string;
  termsSlug: string;
}

export const SEARCH_PAGE_FREE_TEXT_PROJECT_QUERY = gql`
  query freeTextProjects($offset: Int, $perPage: Int, $freeText: String) {
    projectListCarouselQuery: projects(
      request: {
        offset: $offset
        perPage: $perPage
        search: { keyword: $freeText, opr: "AND" }
        orderBy: null
      }
    ) {
      totalCount
      totalPage
      items {
        ...ProjectFields
      }
    }
  }
  ${ProjectFragment}
`;

export interface SearchPageFreeTextProjectsQueryVars {
  offset: number;
  perPage: number;
  freeText: string;
}

export interface ProjectQueryData {
  projectListCarouselQuery: {
    totalCount: number;
    totalPage: number;
    items: ProjectItem[];
  };
}

export const SEARCH_PAGE_LOCATION_NAME_QUERY = gql`
  query searchQuery($slug: String, $termTaxonomy: String) {
    result: termTags(slug: $slug, termTaxonomy: $termTaxonomy) {
      name
    }
  }
`;

export interface SearchPageLocationNameQueryData {
  result: {
    name: string;
  };
}

export interface SearchPageLocationNameQueryVars {
  slug: string;
  termTaxonomy: string;
}
